import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress uncaught errors from external scripts (like Emergent platform scripts)
// that intercept fetch/XHR responses and cause "body already read" errors
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('body stream already read') ||
    event.message.includes('Script error')
  )) {
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
